import { connect } from 'react-redux';

import { supportedApplicationLanguagesWithNativeTranslations as languages } from 'locales/_languages';
import { getCurrentLanguage } from 'modules/language/selectors/language';

import { selectLanguage } from '../../actions/selectLanguage';
import LanguageSelector from './LanguageSelector';

export default connect(
  () => ({
    currentLanguage: languages.find(({ key }) => key === getCurrentLanguage()),
    languages,
  }),
  { selectLanguage },
)(LanguageSelector);
